



















































































import Vue from 'vue'
import ChatWidgetInstruction from './ChatWidgetInstruction.vue'

export default Vue.extend({
  props: ['websiteScreenshot', 'cms'],
  components: {
    ChatWidgetInstruction,
  },
  data() {
    return {
      sending: false,
      hasAccess: undefined,
      showModal: false,
      modalType: 'steps',
      showInstructionModal: false,
      currentLocationId: '',
      cmsName: this.cms,
      cmsData: {} as any,
      cmsInstructions: {
        wordpress: {
          heading: 'Install with WordPress Plug-in',
          steps: [
            {
              text: 'Sign in to your WordPress administration account.',
              img: 'wordpress.png',
              logo: true,
            },
            {
              text: 'Go to <b>Plugins</b>.',
              img: 'WordPress0-min.png',
            },
            {
              text: 'Click <b>Add New</b>.',
              img: 'WordPress1-min.png',
            },
            {
              text: 'Search for Lead Connector and click <b>Install Now</b>.',
              img: 'WordPress2-min.png',
            },
            {
              text: 'Click <b>Activate</b>.',
              img: 'WordPress3-min.png',
            },
            {
              text: 'Copy your API key.',
              img: undefined,
              apiKey: true,
            },
            {
              text: 'Click <b>Lead Connector</b> in left side Navigation.',
              img: 'WordPress4-min.png',
            },
            {
              text: 'Copy and paste your api key.',
              img: 'WordPress5-min.png',
            },
            {
              text: 'Click on <b>Enable Chat-widget</b>',
              img: 'WordPress6-min.png',
            },
            {
              text: 'Click <b>Pull and Save</b>.',
              img: 'WordPress7-min.png',
            },
            {
              text: "Let's make sure widget is working on your website",
              screenshot: true,
            },
          ],
        },
        squarespace: {
          heading: 'Install Webchat on Squarespace',
          steps: [
            {
              text: 'Sign in to your Squarespace administration account.',
              img: 'squarespace.png',
              logo: true,
            },
            {
              text: 'Go to <b>Settings.</b>.',
              img: 'Squarespace0-min.png',
            },
            {
              text: 'Click <b>Advanced.</b>.',
              img: 'Squarespace1-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text: 'Select <b>Code Injection.</b>',
              img: 'Squarespace2-min.png',
            },
            {
              text:
                'Copy and paste the widget code into the <b>HEADER HTML</b>.',
              img: 'Squarespace3-min.png',
            },
            {
              text: 'Click <b>Save.</b>',
              img: 'Squarespace4-min.png',
            },
            {
              text: "Let's make sure widget is working on your website",
              screenshot: true,
            },
          ],
        },
        joomla: {
          heading: 'Install Webchat on Joomla',
          steps: [
            {
              text: 'Sign in to your Joomla administration account.',
              img: 'joomla.png',
              logo: true,
            },
            {
              text: 'Go to <b>Extensions</b> and select <b>Module Manager.</>',
              img: 'Joomla0-min.png',
            },
            {
              text: 'Click <b>New.</b>',
              img: 'Joomla1-min.png',
            },
            {
              text: 'Click <b>Custom HTML.</b>',
              img: 'Joomla2-min.png',
            },
            {
              text: 'In the <b>Position</b> drop-down, select <b>Footer.</b>',
              img: 'Joomla3-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text:
                'In the Custom HTML editor, in Tools select <b>Source Code.</b>',
              img: 'Joomla4-min.png',
            },
            {
              text: 'Copy and paste the widget code, and click <b>Ok.</b>',
              img: 'Joomla5-min.png',
            },
            {
              text: 'Click Menu <b>Assignment.</b>',
              img: 'Joomla7-min.png',
            },
            {
              text:
                'Select <b>On all pages</b> from the Module Assignment drop-down.',
              img: 'Joomla8-min.png',
            },
            {
              text: 'Click <b>Save.</b>',
              img: 'Joomla9-min.png',
            },
            {
              text: "Let's make sure widget is working on your website",
              screenshot: true,
            },
          ],
        },
        duda: {
          heading: 'Install Webchat on Duda',
          steps: [
            {
              text: 'Sign in your Duda administration account.',
              img: 'duda.png',
              logo: true,
            },
            {
              text: 'Click <b>Settings.</b>',
              img: 'Duda0-min.png',
            },
            {
              text: 'Click <b>HEAD HTML.</b>',
              img: 'Duda1-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text:
                'Copy and paste the widget code into the <b>Body End HTML</b>.',
              img: 'Duda2-min.png',
            },
            {
              text: 'Click <b>Save.</b>',
              img: 'Duda3-min.png',
            },
            {
              text: 'Click <b>Republish.</b>',
              img: 'Duda4-min.png',
            },
            {
              text: "Let's make sure widget is working on your website",
              screenshot: true,
            },
          ],
        },
        shopify: {
          heading: 'Install Webchat on Shopify',
          steps: [
            {
              text: 'Sign in to your Shopify administration account.',
              img: 'shopify.png',
              logo: true,
            },
            {
              text: 'Go to <b>Online Store</b> and select <b>Themes.</b>',
              img: 'Shopify0-min.png',
            },
            {
              text: 'Click <b>Actions</b> and select <b>Edit code.</b>',
              img: 'Shopify1-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text: 'Expand <b>Layout</b> and click theme.liquid.',
              img: 'Shopify2-min.png',
            },
            {
              text:
                'Copy and paste the widget code above the <b><</b><b>/body></b> tag.',
              img: 'Shopify3-min.png',
            },
            {
              text: 'Click <b>Save.</b>',
              img: 'Shopify4-min.png',
            },
            {
              text: "Let's make sure widget is working on your website.",
              screenshot: true,
            },
          ],
        },
        weebly: {
          heading: 'Install Webchat on Weebly',
          steps: [
            {
              text: 'Sign in to your Weebly administration account.',
              img: 'weebly-logo-2.png',
              logo: true,
            },
            {
              text: 'Go to <b>Theme.</b>',
              img: 'Weebly1-min.png',
            },
            {
              text: 'Click <b>Edit HTML/CSS.</b>',
              img: 'Weebly2-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text: 'Click <b>header.html.</b>',
              img: 'Weebly3-min.png',
            },
            {
              text:
                'In the header, paste the widget code above the <b><</b><b>/body></b> tag.',
              img: 'Weebly4-min.png',
            },
            {
              text: 'Click <b>Save.</b>',
              img: 'Weebly5-min.png',
            },
            {
              text: 'Click <b>Publish</b>',
              img: 'Weebly6-min.png',
            },
            {
              text: "Let's make sure widget is working on your website.",
              screenshot: true,
            },
          ],
        },
        other: {
          heading: 'Install Webchat on your Website',
          steps: [
            {
              text: 'Sign in to your (CMS) account.',
              img: 'Other1-min.png',
            },
            {
              text: 'Copy your widget code.',
              img: undefined,
              widgetCode: true,
            },
            {
              text:
                'Copy and paste the widget code snippet right before the <b><</b><b>/body></b> tag on each page you want the widget to appear.',
              img: 'Other2-min.png',
            },
            {
              text: 'Save the changes.',
              img: 'Other2-min.png',
            },
            {
              text: "Let's make sure widget is working on your website.",
              screenshot: true,
            },
          ],
        },
      },
    }
  },
  computed: {
    disableAction(): boolean {
      return this.hasAccess === undefined
    },
  },
  mounted() {
    this.$root.$on('set-cms', (cms: any) => {
      this.cmsName = cms
      this.cmsData = this.cmsInstructions[cms.toLowerCase()]
    })
    this.cmsData = this.cmsInstructions[this.cms.toLowerCase()]
    this.$root.$on('close-modal', () => {
      this.modalType = 'steps'
      this.showModal = false
    })
    this.$root.$on('modal-type', (type: string) => {
      this.showModal = true
      this.modalType = type
    })
    if (this.cmsName.toLowerCase() == 'other') {
      this.changeCms()
    }
  },
  watch: {
    cms: async function () {
      this.cmsName = this.cms
      this.cmsData = this.cmsInstructions[this.cms.toLowerCase()]
    },
  },
  methods: {
    backToLaunchpad() {
      this.$root.$emit('hide-widget-setup')
    },
    showSteps() {
      this.showModal = true
      if (this.hasAccess == 'yes') {
        this.modalType = 'steps'
      } else {
        this.modalType = 'send-instructions'
      }
    },
    changeCms() {
      this.showModal = true
      this.modalType = 'cms-select'
    },
  },
})
